import { ApolloError } from 'apollo-boost';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../BaseComponents';
import { useTheme } from '../../../theme';

interface Props {
	error: ApolloError;
	buttonText?: string;
	title?: string;
}

const ErrorMessage: React.FC<Props> = ({ error, buttonText, title }) => {
	const { t } = useTranslation('CompareFares');
	const { ErrorMessage: css } = useTheme('CompareFares');

	if (!error) {
		return null;
	}

	return (
		<div className={css.errorWrapper}>
			<h6 className={css.errorTitle}>{title ?? t('Internal error')}</h6>
			<p className={css.errorText}>{error.message}</p>

			<BaseButton variant="optionAction">{buttonText ?? t('Label')}</BaseButton>
		</div>
	);
};

export default ErrorMessage;
